<template>
  <v-container fluid full-height grid-list-md>
    <v-layout row wrap>
      <v-flex xs6>
        <div class="text-xs-left">
          <v-breadcrumbs :items="breadcrumbs" divider=">"></v-breadcrumbs>
        </div>
      </v-flex>
      <v-flex xs6>
        <div style="display: flex; justify-content: flex-end;">
          <v-menu offset-y v-if="user.role.roleName != 'WAREHOUSE_MANAGER'">
            <template v-slot:activator="{on,attrs}">
              <v-btn
              color="primary"
              v-bind="attrs"
              v-on="on"
              >
                <v-icon>add_circle</v-icon>Add
              </v-btn>
            </template>
            <v-list>
              <v-list-tile @click="onRegister">
                <v-list-tile-content>
                  <v-list-tile-title>ADD NEW</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
            </v-list>
          </v-menu>

          <v-btn @click="showFilters = !showFilters" color="#FF4545">
            <v-icon>filter_list</v-icon>Filter
            <v-icon>{{ showFilters ? 'arrow_drop_up' : 'arrow_drop_down' }}</v-icon>
          </v-btn>
        </div>
      </v-flex>
      <v-flex xs12 v-if="showFilters">
        <v-card>
          <v-layout row wrap class="pa-3">
            <v-flex sm4>
              <v-menu
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <v-text-field
                  slot="activator"
                  v-model="queryParams.fromDate"
                  label="From Date"
                  prepend-icon="event"
                  readonly
                ></v-text-field>
                <v-date-picker v-model="queryParams.fromDate"></v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex sm4>
              <v-menu
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <v-text-field
                  slot="activator"
                  v-model="queryParams.toDate"
                  label="To Date"
                  prepend-icon="event"
                  readonly
                ></v-text-field>
                <v-date-picker v-model="queryParams.toDate"></v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex sm4>
              <v-text-field
                name="issueNo"
                label="Issue No"
                type="text"
                v-model="queryParams.invoiceNo"
              ></v-text-field>
            </v-flex>
            <v-flex sm4>
              <v-text-field
                name="creditNoteNo"
                label="Credit Note No"
                type="text"
                v-model="queryParams.creditNoteNo"
              ></v-text-field>
            </v-flex>
            <v-flex sm4>
              <v-text-field
                name="customerName"
                label="Customer Name"
                type="text"
                v-model="queryParams.customerName"
              ></v-text-field>
            </v-flex>
            <v-flex sm4>
              <v-text-field
                name="customerCode"
                label="Customer Code"
                type="text"
                v-model="queryParams.customerCode"
              ></v-text-field>
            </v-flex>
            <v-flex sm4>
              <v-select
                :items="damageStatusList"
                label="Choose Status..."
                :hide-no-data="true"
                color="blue-grey lighten-2"
                item-text="label"
                item-value="value"
                menu-props="auto"
                v-model="queryParams.status"
              ></v-select>
            </v-flex>
            <v-flex sm4 v-if="user.role.roleName == 'ADMIN' || user.role.roleName == 'FINANCE_MANAGER' || user.role.roleName == 'BRANCH_ADMIN'">
              <v-select
                :items="shopList"
                label="Choose Shop..."
                item-text="name"
                color="blue-grey lighten-2"
                menu-props="auto"
                item-value="id"
                :readonly="user.role.roleName == 'BRANCH_ADMIN'"
                v-model="queryParams.shopId"
              ></v-select>
            </v-flex>
            <v-flex sm4>
              <v-select
                :items="invoiceTypeList"
                label="Choose Invoice Type..."
                :hide-no-data="true"
                color="blue-grey lighten-2"
                item-text="label"
                item-value="value"
                menu-props="auto"
                v-model="queryParams.invoiceType"
              ></v-select>
            </v-flex>
            <v-flex sm4>
              <v-autocomplete
                v-model="queryParams.saleTeamIds"
                :items="saleTeamList"
                label="Sale Team"
                item-text="name"
                item-value="id"
                menu-props="auto"
                multiple
              ></v-autocomplete>
            </v-flex>
            <v-flex sm4>
              <v-autocomplete
                :items="typeList"
                label="Type"
                v-model="queryParams.type"
                item-text="text"
                item-value="value"
                menu-props="auto"
              ></v-autocomplete>
            </v-flex>
            <v-flex sm2>
              <v-btn outline color="primary" @click="onSearch">
                Search
                <v-icon right>search</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
      <v-flex xs12 class="mt-1">
        <v-card>
          <v-data-table
            :must-sort="true"
            :headers="headers"
            :items="damageList"
            class="elevation-1"
            :loading="showListLoading"
            :total-items="totalRows"
            :rows-per-page-items="rowsPerPageItems"
            :pagination.sync="pagination"
          >
          <template slot="items" slot-scope="props">
              <td>
                <v-btn flat icon color="blue lighten-2" @click="onEdit(props.item)">
                  <v-icon>edit</v-icon>
                </v-btn>
              </td>
              <td>{{ props.item.damageStatus }}</td>
              <td>{{ props.item.issueDateInMilliSeconds | format-ms-date}}</td>
              <td>{{ props.item.invoiceNo }}</td>
              <td>{{ props.item.creditNoteNo }}</td>
              <td>{{ props.item.customerDTO.name }}</td>
              <td>{{ props.item.customerDTO.code }}</td>
              <td>{{ props.item.shopDTO.name }}</td>
              <td>{{ props.item.saleTeamName }}</td>
              <td>{{ props.item.invoiceType }}</td>
              <td>{{ props.item.creditInvoiceId }}</td>
              <td>{{ props.item.shopDTO.regionName }}</td>
              <td style="text-align: right">{{ props.item.totalAmount | decFormat(6)}}</td>
              <td>{{ props.item.remark }}</td>
              <td>{{ props.item.updatedBy }}</td>
              <td>
                <v-btn color="primary" @click.stop="printDamageInvoice(props.item.id)">PRINT</v-btn>
              </td>
            </template>
          </v-data-table>
        </v-card>
      </v-flex>
    </v-layout>

    <!-- <damage report> -->
    <div id="printAllDamageList" style="bsale:1px solid black;width:300px;" v-show="false">
      <div style="text-align:center">
        <p style="font-size:18px;margin:1px">Damage Invoice</p>
      </div>
      <div style="text-align:center">
        <p
          style="font-size:15px;margin:1px"
        >From: [{{queryParams.fromDate}}] To: [{{queryParams.toDate}}]</p>
      </div>
      <div style="text-align:left">
        <p
          style="font-size:15px;margin:1px"
        >Total Amount : {{totalDamageAmount | decFormat(6) }}</p>
      </div>
      <br />
      <div style="padding-left:5px;padding-right:5px">
        <table
          style="font-family: arial, sans-serif;border-collapse: collapse;width: 100%;font-size:11px;"
        >
          <thead style="border-bottom:1px solid black;border-top:1px solid black">
            <tr>
              <th style="text-align:left">Invoice Date</th>
              <th style="text-align:left">Invoice No</th>
              <th style="text-align:left">Customer Name</th>
              <th style="text-align:left">Customer Code</th>
              <th style="text-align:left">Shop Name</th>
              <th style="text-align:left">Invoice Type</th>
              <th style="text-align:left">Status</th>
              <th style="text-align:left">Region</th>
              <th style="text-align:left">Total Damage Amount</th>
              <th style="text-align:left">Remark</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in allDamageList" :key="index">
              <td style="text-align:left">{{item.updatedDateInMilliSeconds | format-ms-date}}</td>
              <td style="text-align:left">{{item.invoiceNo}}</td>
              <td style="text-align:left">{{item.customerDTO.name}}</td>
              <td style="text-align:left">{{item.customerDTO.code}}</td>
              <td style="text-align:left">{{item.shopDTO.name}}</td>
              <td style="text-align:left">{{item.invoiceType }}</td>
              <td style="text-align:left">{{item.damageStatus }}</td>
              <td style="text-align:left">{{item.shopDTO.regionName }}</td>
              <td style="text-align:right">{{item.totalAmount | decFormat(6)}}</td>
              <td style="text-align:left">{{item.remark }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </v-container>
</template>
<script>
import { shopService } from "../../services/shop-service";
import { damageService } from "../../services/damage-service";
import { saleTeamService } from "../../services/sale-team-service";
import { commonService } from "../../services/common-service";

export default {
  name: "DamageList",
  data: () => ({
    user: JSON.parse(localStorage.getItem("user")),
    showFilters: false,
    breadcrumbs: [
      {
        text: "Finance",
        disabled: true,
      },
      {
        text: "Invoice",
        disabled: true,
      },
    ],
    headers: [
      { text: "Action", sortable: false },
      { text: "Status", value: "status", sortable: false },
      {
        text: "Issue Date",
        align: "left",
        value: "warehouse.name",
        sortable: false,
      },
      { text: "Issue No", align: "left", value: "bin.name", sortable: false },
      { text: "Credit Note No", align: "left", value: "creditNoteNo", sortable: false },
      { text: "Customer Name", value: "issueDate", sortable: false },
      { text: "Customer Code", value: "issueNo", sortable: false },
      { text: "Shop Name", value: "poNo", sortable: false },
      { text: "Sale Team", sortable: false },
      { text: "Invoice Type", value: "invoiceType", sortable: false },
      { text: "Sale No", value: "creditInvoiceId", sortable: false },
      { text: "Region", value: "description", sortable: false },
      { text: "Total Amount", value: "updatedDate", sortable: false },
      { text: "Remark", align: "center", sortable: false },
      { text: "Updated  By", value: "updatedBy", sortable: false },
      { text: "Print", sortable: false },
    ],
    damageStatusList: [
      { label: "----All----", value: "" },
      { label: "DRAFT", value: "DRAFT" },
      { label: "CONFIRM", value: "CONFIRM" },
      { label: "CANCEL", value: "CANCEL" },
    ],
    queryParams: {
      fromDate: commonService.formatDate(new Date(), "YYYY-MM-DD"),
      toDate: commonService.formatDate(new Date(), "YYYY-MM-DD"),
      invoiceNo: "",
      customerName: "",
      customerCode: "",
      shopId: "",
      status: "",
      invoiceType: "",
      updateUserId: "",
      saleTeamIds: "",
      creditNoteNo: "",
      type: "",
    },
    rowsPerPageItems: [25, 50, 100],
    pagination: {
      descending: true,
      page: 1,
      rowsPerPage: 50,
      sortBy: "updatedDate",
      totalItems: 0,
    },
    decimalFormat: "",
    totalDamageAmount: 0,
    totalAmount: 0,
    totalRows: 0,
    showListLoading: false,
    buttonLoading: false,
    printAllButtonLoading: false,
    clonequeryParams: new Object(),
    shopList: [],
    damageList: [],
    allDamageList: [],
    invoiceTypeList: [ { label: "---All---", value: "" } ],
    typeList: [
      { text: "ALL", value: "" },
      { text: "With Invoice", value: "INVOICE" },
      { text: "Without Invoice", value: "NO_INVOICE" },
    ],
    saleTeamList: [],
  }),
  created() {
    this.getAllShop();
    this.getActiveSaleTeams();
    this.decimalFormat = commonService.formatdecimal();
    //for deep linking
    if (this.$route.query.fromDate) {
      this.queryParams.fromDate = this.$route.query.fromDate;
    }
    if (this.$route.query.toDate) {
      this.queryParams.toDate = this.$route.query.toDate;
    }
    if (this.$route.query.invoiceNo) {
      this.queryParams.invoiceNo = this.$route.query.invoiceNo;
    }
    if (this.$route.query.customerName) {
      this.queryParams.customerName = this.$route.query.customerName;
    }
    if (this.$route.query.customerCode) {
      this.queryParams.customerCode = this.$route.query.customerCode;
    }
    if (this.$route.query.status) {
      this.queryParams.status = this.$route.query.status;
    }
    if (this.$route.query.shopId) {
      this.queryParams.shopId = Number(this.$route.query.shopId);
    }
    if (this.$route.query.updateUserId) {
      this.queryParams.updateUserId = Number(this.$route.query.updateUserId);
    }
    if (this.$route.query.saleTeamIds) {
      if (Array.isArray(this.$route.query.saleTeamIds)) {
        this.queryParams.saleTeamIds = this.$route.query.saleTeamIds.map(Number);
      } else {
        this.queryParams.saleTeamIds = [ Number(this.$route.query.saleTeamIds) ];
      }
    }
    if (this.$route.query.type) {
      this.queryParams.type = this.$route.query.type;
    }
    if (this.$route.query.creditNoteNo) {
      this.queryParams.creditNoteNo = this.$route.query.creditNoteNo;
    }
    if (this.$route.query.invoiceType) {
      this.queryParams.invoiceType = this.$route.query.invoiceType;
    }
    if (this.$route.query.page) {
      this.pagination.page = this.$route.query.page;
    }
    if (this.$route.query.size) {
      this.pagination.size = this.$route.query.size;
    }
     if (this.user.role.roleName == "SALE_MANAGER" || this.user.role.roleName =="GENERAL_MANAGER" || this.user.role.roleName =="BRANCH_ADMIN") {
      this.queryParams.shopId = this.user.shopId;
      if (this.user.role.roleName == "SALE_MANAGER") {
        this.queryParams.updateUserId = this.user.id;
      }
    }
    this.onSearch();
    this.getAllInvoiceType();
    this.decimalFormat = commonService.formatdecimal();
  },

  methods: {
    onSearch() {
      this.queryParams.page = this.pagination.page;
      this.queryParams.size = this.pagination.rowsPerPage;
      this.$router.replace({ name: "damages", query: this.queryParams });
      this.clonequeryParams = Object.assign({}, this.queryParams);
      this.getDamageList();
    },

    getAllShop() {
      shopService
        .getAllShop()
        .then((res) => {
          this.shopList = res.data;
          let findAll = {
            id: "",
            name: "----All----",
          };
          this.shopList.splice(0, 0, JSON.parse(JSON.stringify(findAll)));
        })
        .catch((err) => {
          console.log(err);
          if (err.response.data) {
            this.responseError = err.response.data.message;
          }
        });
    },
    getActiveSaleTeams() {
      saleTeamService
        .getSaleTeamsByStatus("ACTIVE")
        .then((res) => {
          this.saleTeamList = res.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getDamageList() {
      this.showListLoading = true;
      let order = this.pagination.descending ? "desc" : "asc";
      damageService
        .getDamageList(
          this.queryParams,
          this.pagination.page,
          this.pagination.rowsPerPage,
          this.pagination.sortBy + "," + order
        )
        .then((res) => {
          if (res.data) {
            this.damageList = res.data.damageHeaderList;
            this.totalRows = res.data.totalElements;
            this.totalDamageAmount = res.data.totalDamageAmount;
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.showListLoading = false;
        });
    },
    onRegister() {
      this.$router.push("/damage/new");
    },
    onEdit(damage) {
      // go to details page
      this.$router.push("/damage/" + damage.id);
    },
    printDamageInvoice(id) {
      damageService.printDamageInvoice(id).then((res) => {
        var blob = res;
        damageService.showWindowDialog(blob, "invoice-" + id);
      });
    },
    getAllInvoiceType() {
      damageService
      .getAllDamageInvoiceType()
      .then((res)=>{
        let tempList = res.data;
        tempList.forEach((item)=>{
          let tempObj = { label: item, value: item };
          if (item == "SALE_RETURN") {
            this.invoiceTypeList.push(tempObj);
          }
        })
      })
    }
  },
};
</script>